<emergency-contact [user]="user"></emergency-contact>